// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeNotificationSettingsGetGameBody = {
  eventId: string;
};

export type typeNotificationSettingsGetGameOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    isFollowing: boolean;
    alerts: {
      alertKindKey: string;
      label: string;
      isEnabled: boolean;
      isOnByDefault: boolean;
    }[];
  };
};

export type typeNotificationSettingsGetGameOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetGameOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeNotificationSettingsGetGameOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaNotificationSettingsGetGameBody = {
  type: "object",
  properties: { eventId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["eventId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createNotificationSettingsGetGame(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaNotificationSettingsGetGameBody);
  }

  return async function postNotificationSettingsGetGame(
    payload: typeNotificationSettingsGetGameBody,
  ): Promise<
    | typeNotificationSettingsGetGameOutput200
    | typeNotificationSettingsGetGameOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postNotificationSettingsGetGame" failed before calling the network. #3ca4265afccd`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#3ca4265afccd" },
        },
        data: null,
      } as typeNotificationSettingsGetGameOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/notification-settings/get-game`,
      httpMethod: "POST",
      options,
    })) as
      | typeNotificationSettingsGetGameOutput200
      | typeNotificationSettingsGetGameOutput400;
  };
}
